if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        // Intercept popup form submit to prevent immediate reload
        const form = this.querySelector('form');
        if (form && !form.dataset.ajaxBound) {
          form.dataset.ajaxBound = 'true';

          form.addEventListener('submit', (e) => {
            // 1. Block default reload and stop other theme scripts from force-refreshing
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // 2. Submit form via AJAX in background
            fetch(form.action || '/contact', {
              method: 'POST',
              body: new FormData(form)
            }).then(() => {
              // 3. Save cookie right away so page reload won't trigger pop-up
              this.setCookie(this.cookieName, this.expiry || 30);

              // 4. Hide inputs and button
              const inputs = form.querySelectorAll('.field, input, button, .newsletter-form__field-wrapper');
              inputs.forEach(el => el.style.display = 'none');

              // 5. Show success message inside the popup
              let successMessage = this.querySelector('.alert--success, .form-status--success');
              if (successMessage) {
                successMessage.style.display = 'block';
              } else {
                successMessage = document.createElement('div');
                successMessage.className = 'alert alert--success';
                successMessage.style.padding = '15px';
                successMessage.style.marginTop = '10px';
                successMessage.innerText = 'Tak for dit abonnement';
                form.appendChild(successMessage);
              }

              // 6. Hold the message on screen for 3 full seconds before refreshing
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }).catch(() => {
              // Fallback: Submit normally if network fails
              form.submit();
            });
          }, true); // Enforces capture phase to run before other scripts
        }

        // Standard check to show pop-up if no cookie exists
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
